{
  "version": 1,
  "asset_id": "d7784645-c636-4535-8208-9b7a2f32ef18",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/d7784645-c636-4535-8208-9b7a2f32ef18/dirty-stamped-concrete-poster.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/d7784645-c636-4535-8208-9b7a2f32ef18/dirty-stamped-concrete-poster.webp",
  "original_filename": "dirty-stamped-concrete-poster.webp",
  "size": 65942,
  "content_type": "image/webp",
  "created_at": "2026-09-11T23:20:15Z"
}
